export const cleanFeedbackMessage = (message: string) => {
    return (
        message
            // clean numbers
            .replace(/\b(\d+[\d\s()-]+\d+)\b/gi, (match) => {
                const clean = match.replace(/[\s()-]*/gi, '');
                const stars = clean.length > 8 ? new Array(clean.length - 5).fill('*').join('') : '';
                return clean.slice(0, 5) + stars;
            })
            // clean emails
            .replace(/\w([\w\d]+)@\w/gi, (match) => {
                const stars = new Array(match.length - 5).fill('*').join('');
                return match.slice(0, 1) + stars + match.slice(-2);
            })
    );
};
